<template>
  <div>
    <AsyncLSelect :close-on-select="closeOnSelect" v-bind="$props" v-on="$listeners">
      <template v-for="(_,slotName) in $scopedSlots" v-slot:[slotName]="{data}">
        <slot :name="slotName" v-bind:data="data"/>
      </template>
      <template
          v-slot:option-content="{data:{optionsData, handleClickOptionItem, checkItemIsSelected}}">
        <OptionItems
            :checkItemIsSelected="checkItemIsSelected"
            :handleClickOptionItem="handleClickOptionItem"
            :multiple="multiple"
            :optionsData="optionsData"
        />
      </template>
    </AsyncLSelect>
  </div>

</template>

<script>
import AsyncLSelect from "@/components/select/LSelect/AsyncLSelect.vue";
import OptionItems from "@/components/select/LSelect/components/OptionItems.vue";

export default {
  name: "LSelectTree",
  components: {AsyncLSelect, OptionItems},
  props: {
    fieldLabel: {
      type: String,
      default: "text"
    },
    value: [Number, String, Array, Object],
    label: String,
    multiple: {
      type: Boolean,
      default: false,
    },
    returnObj: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    search: {
      type: [Function, undefined],
      default: null,
    },
    closeOnSelect: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    rules: String,
    params: {
      type: Object,
      default: () => {
      }
    },
    hintClass: [String, Array],
    hint: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: "font-light"
    },
    expandCheckItem: {
      type: Boolean,
      default: true,
    },
    alwaysShowMenu: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 8,
    },
    hiddenInput: {
      type: Boolean,
      default: false,
    },
    absoluteClass:{
      type: Boolean,
      default: true,
    }
  },
  watch: {},
  methods: {}
}
</script>

<style scoped>

</style>
